import { useSelector } from 'react-redux'
import { PlanGroupCategoryEnum } from 'settings/_planGroupSettings'

interface AuthState {
  auth: {
    planSelected: {
      plan_group: {
        category: string
      }
    }
  }
}

interface PlanType {
  isCorporate: boolean
  isEnterprise: boolean
  isParticular: boolean
  isVitta: boolean
  isCapitation: boolean
}

export const usePatientPlanType = (): PlanType => {
  const planGroupCategory = useSelector(
    (state: AuthState) => state.auth.planSelected?.plan_group.category
  )
  
  const {
    CAPITATION,
    CARE_PLUS,
    ENTERPRISE,
    PARTICULAR,
    VITTA,
    CORPORATE_LIMITED,
    CORPORATE_UNLIMITED,
  } = PlanGroupCategoryEnum as Record<string, string>
  
  const isCorporate = [CORPORATE_LIMITED, CORPORATE_UNLIMITED].includes(planGroupCategory)
  const isEnterprise = [ENTERPRISE, CARE_PLUS].includes(planGroupCategory)
  const isParticular = planGroupCategory === PARTICULAR
  const isVitta = planGroupCategory === VITTA
  const isCapitation = planGroupCategory === CAPITATION
  
  return { 
    isCorporate, 
    isEnterprise, 
    isParticular, 
    isVitta, 
    isCapitation 
  }
}